import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Favorite} from '@models/favorite';
import {AdService} from '@services/ad.service';

@Component({
    selector: 'app-edit-description',
    templateUrl: './edit-description.component.html',
    styleUrls: ['./edit-description.component.scss']
})
export class EditDescriptionComponent {

    favorite: Favorite;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public adService: AdService,
        public dialogRef: MatDialogRef<EditDescriptionComponent>) {
        this.favorite = Object.assign({}, data.favorite);
        this.favorite.ad = Object.assign({}, data.favorite.ad);
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.favorite = this.adService.updateValues(this.favorite);
        this.dialogRef.close(this.favorite);
    }
}
